export const GET_SKILLS = 'GET_SKILLS'
export const GET_SKILLS_REQUEST = 'GET_SKILLS_REQUEST'
export const GET_SKILLS_ERROR = 'GET_SKILLS_ERROR'
export const SET_SKILLS = 'SET_SKILLS'
export const GET_ARTIST_TYPES = 'GET_ARTIST_TYPES'
export const GET_ARTIST_TYPES_REQUEST = 'GET_ARTIST_TYPES_REQUEST'
export const GET_ARTIST_TYPES_ERROR = 'GET_ARTIST_TYPES_ERROR'
export const SET_ARTIST_TYPES = 'SET_ARTIST_TYPES'
export const GET_JOB_ADS = 'GET_JOB_ADS'
export const JOB_ADS_REQUEST = 'JOB_ADS_REQUEST'
export const JOB_ADS_SUCCESS = 'JOB_ADS_SUCCESS'
export const JOB_ADS_ERROR = 'JOB_ADS_ERROR'
